import { render } from "./ControlsRightComponent.vue?vue&type=template&id=3000f406&scoped=true&ts=true"
import script from "./ControlsRightComponent.vue?vue&type=script&lang=ts"
export * from "./ControlsRightComponent.vue?vue&type=script&lang=ts"

import "./ControlsRightComponent.vue?vue&type=style&index=0&id=3000f406&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3000f406"]])

export default __exports__